import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { RadioButton } from 'primereact/radiobutton';
// import DynamicDataTable from '../../../components/DynamicDataTable/DynamicDataTable';
import { connect } from 'react-redux';
import { getKeywordValues } from '../../store/actions';
import FooterButton from '../../shared/UI/FooterButton/FooterButton';
import { REDIRECT_TO_URL, HASACCESS } from '../../shared/utility';
import { USER_SUBMENU_ID } from '../../shared/Config';
import Messages from '../../shared/UI/Messages/Messages';




class InventorySettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
             type: 'add',
            Id: null,
            assemblyName: '',
            Status: 'available',
             allowOrderEdit: false,
            enableKitchenPrint: false,
            enableTableTransfer: false,
            enableLoyalty: false,
            autoShiftClose: false,
            discountApproval: 'No',
            splitBill: 'No',
            negativeStock: 'No',
            takeAway: 'No',
            deliveryOrder: 'No',
            taxEdit: 'No',

        };
        this.growl = null;
    }

    // componentDidMount() {        
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);
    // }
//  componentDidMount() {
//     this.getAccess = HASACCESS(USER_SUBMENU_ID);

//     const type = this.props.match.params.type;

//     if (type !== 'add') {
//         // Fetch assembly details by id
//         const id = this.props.match.params.id;

//         // Example
//         // this.props.getMasterTableList('GeAssembly?id=' + id);

//         this.timer();
//     }
// }

     timer = () =>{
        this.intervalID = setInterval(()=> {
            this.fetchSingleProcess();
        },2000)
    }    
    // componentWillUnmount(){
    //     if(this.props.tableLists.usersList!==undefined) {
    //         clearInterval(this.intervalID);
    //     }
    // }

    fetchSingleProcess = () => {

        const type = this.props.match.params.type;

        let assemblyData = null;

        if (this.props.tableLists &&
            this.props.tableLists.assembly) {

            assemblyData = this.props.tableLists.assembly;

            clearInterval(this.intervalID);
        }

        if (assemblyData) {

            const data = {
                type: type,
                Id: assemblyData.id,
                assemblyName: assemblyData.assemblyName || '',
                rows: (assemblyData.comboItems || []).map((item, index) => ({
                    _id: index + 1,
                    dish: item.dishId,
                    quantity: item.quantity,
                    unit: item.unit,
                    status: item.status
                }))
            };

            this.setState(data);
        }
    }

     add = () => {

        var data = {
            Id: null,
            EmployeeId: this.state.EmployeeId,  
            AssemblyId: this.state.AssemblyId,          
            AssemblyName: this.state.assemblyName,
            IsActive: this.state.IsActive,
             Status: this.state.Status,
            ComboItems: this.state.rows.map(row => ({
                DishId: row.dish,
                Quantity: row.quantity,
                Unit: row.unit,
                Status: row.status
            })),
            CompanyId : this.state.CompanyId,
            CreatedBy : this.state.createdBy,
            CreatedDate : this.state.createdDate,

        
        }
   
        
        if(this.state.type === 'edit'){
            data.AssemblyId = this.state.AssemblyId;
            data.Id = this.state.Id
        }

        this.props.processDynamicData('Assembly',this.state.type,data,'GetAssembly');

    }

       resetData = () => {
        this.setState({
            type: 'add',
            Id: null,
            assemblyName: '',
            Status: 'available',
            rows: [
                {
                    _id: 1,
                    dish: null,
                    quantity: '',
                    unit: null,
                    status: 'available'
                }
            ]
        });
    }



    render() {
          if(this.props.success){
                    REDIRECT_TO_URL('/Dashboard/',this.props);
                }
        
        
                let addAccess = true;
                let editAccess = true;
                if(this.getAccess!==undefined){
                    if(this.getAccess.viewAccess === false && this.props.userDetail.userId!==this.props.match.params.id){this.props.history.push('/dashboard')}
                    addAccess = (this.getAccess.addAccess === true) ? true : false;
                    editAccess = (this.getAccess.editAccess === true) ? true : false;
                }
                let accessButton = { addAccess : addAccess, editAccess : editAccess}
                
                let roleOptions = [];
                if(this.props.Role && this.props.Role.length > 0 ){
                    roleOptions = this.props.Role;
                }
                let approvalroleOptions = [];
                if(this.props.ApprovalRole && this.props.ApprovalRole.length > 0 ){
                    approvalroleOptions = this.props.ApprovalRole;
                }
        
                // let isEnabled = (this.state.touch === true);
                let isEnabled = this.state.assemblyName.trim() !== '' && this.state.rows.length > 0 && this.state.rows.every(row => row.dish && row.quantity && row.unit);
                // let isEnabled = (this.state.assemblyName.trim() !== '' && this.state.rows.every(row => row.dish)) ? true : false;
        
                let redirectURL = '/dashboard/';
                if(this.props.userDetail && this.props.match.params.id!==undefined){
                    if(this.props.userDetail.userId === this.props.match.params.id){
                        redirectURL = "/dashboard";
                    }
                }

        const { assemblyName, rows } = this.state;
        
        return (
              <div className="p-grid">
                           { this.props.loading && <div className="page-loader"></div>}
                           { this.state.loading && <div className="page-loader"></div>}
                           { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                           { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                           <Toast ref={(el) => this.growl = el} />
            
                           <div className="p-col-12">
                                <div className="card card-w-title" style={{position:'relative'}}>
                                    <h1>Inventory Settings</h1>
            <div className="p-grid">

            {/* ================= SWITCHES ================= */}

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Allow Waiter Order Edit</label>
                <div className="mt1">
                    <InputSwitch
                        checked={this.state.allowOrderEdit}
                        onChange={(e) => this.setState({ allowOrderEdit: e.value })}
                    />
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Enable Kitchen Printing</label>
                <div className="mt1">
                    <InputSwitch
                        checked={this.state.enableKitchenPrint}
                        onChange={(e) => this.setState({ enableKitchenPrint: e.value })}
                    />
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Allow Table Transfer</label>
                <div className="mt1">
                    <InputSwitch
                        checked={this.state.enableTableTransfer}
                        onChange={(e) => this.setState({ enableTableTransfer: e.value })}
                    />
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Enable Loyalty Points</label>
                <div className="mt1">
                    <InputSwitch
                        checked={this.state.enableLoyalty}
                        onChange={(e) => this.setState({ enableLoyalty: e.value })}
                    />
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Auto Shift Closing</label>
                <div className="mt1">
                    <InputSwitch
                        checked={this.state.autoShiftClose}
                        onChange={(e) => this.setState({ autoShiftClose: e.value })}
                    />
                </div>
            </div>

            {/* ================= RADIO GROUPS ================= */}

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Allow Discount Without Approval?</label>
                <div className="mt1">
                    <RadioButton
                        inputId="discountYes"
                        name="discountApproval"
                        value="Yes"
                        checked={this.state.discountApproval === 'Yes'}
                        onChange={this.handleChange}
                    />
                    <label htmlFor="discountYes" className="ml05 mr1">Yes</label>

                    <RadioButton
                        inputId="discountNo"
                        name="discountApproval"
                        value="No"
                        checked={this.state.discountApproval === 'No'}
                        onChange={this.handleChange}
                    />
                    <label htmlFor="discountNo" className="ml05">No</label>
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Allow Split Bill?</label>
                <div className="mt1">
                    <RadioButton inputId="splitYes" name="splitBill" value="Yes"
                        checked={this.state.splitBill === 'Yes'} onChange={this.handleChange} />
                    <label htmlFor="splitYes" className="ml05 mr1">Yes</label>

                    <RadioButton inputId="splitNo" name="splitBill" value="No"
                        checked={this.state.splitBill === 'No'} onChange={this.handleChange} />
                    <label htmlFor="splitNo" className="ml05">No</label>
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Allow Negative Stock Sale?</label>
                <div className="mt1">
                    <RadioButton inputId="stockYes" name="negativeStock" value="Yes"
                        checked={this.state.negativeStock === 'Yes'} onChange={this.handleChange} />
                    <label htmlFor="stockYes" className="ml05 mr1">Yes</label>

                    <RadioButton inputId="stockNo" name="negativeStock" value="No"
                        checked={this.state.negativeStock === 'No'} onChange={this.handleChange} />
                    <label htmlFor="stockNo" className="ml05">No</label>
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Enable Take Away Orders?</label>
                <div className="mt1">
                    <RadioButton inputId="takeAwayYes" name="takeAway" value="Yes"
                        checked={this.state.takeAway === 'Yes'} onChange={this.handleChange} />
                    <label htmlFor="takeAwayYes" className="ml05 mr1">Yes</label>

                    <RadioButton inputId="takeAwayNo" name="takeAway" value="No"
                        checked={this.state.takeAway === 'No'} onChange={this.handleChange} />
                    <label htmlFor="takeAwayNo" className="ml05">No</label>
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Enable Delivery Orders?</label>
                <div className="mt1">
                    <RadioButton inputId="deliveryYes" name="deliveryOrder" value="Yes"
                        checked={this.state.deliveryOrder === 'Yes'} onChange={this.handleChange} />
                    <label htmlFor="deliveryYes" className="ml05 mr1">Yes</label>

                    <RadioButton inputId="deliveryNo" name="deliveryOrder" value="No"
                        checked={this.state.deliveryOrder === 'No'} onChange={this.handleChange} />
                    <label htmlFor="deliveryNo" className="ml05">No</label>
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Allow Manual Tax Edit?</label>
                <div className="mt1">
                    <RadioButton inputId="taxYes" name="taxEdit" value="Yes"
                        checked={this.state.taxEdit === 'Yes'} onChange={this.handleChange} />
                    <label htmlFor="taxYes" className="ml05 mr1">Yes</label>

                    <RadioButton inputId="taxNo" name="taxEdit" value="No"
                        checked={this.state.taxEdit === 'No'} onChange={this.handleChange} />
                    <label htmlFor="taxNo" className="ml05">No</label>
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Require Customer Mobile?</label>
                <div className="mt1">
                    <RadioButton inputId="mobileYes" name="customerMobile" value="Yes"
                        checked={this.state.customerMobile === 'Yes'} onChange={this.handleChange} />
                    <label htmlFor="mobileYes" className="ml05 mr1">Yes</label>

                    <RadioButton inputId="mobileNo" name="customerMobile" value="No"
                        checked={this.state.customerMobile === 'No'} onChange={this.handleChange} />
                    <label htmlFor="mobileNo" className="ml05">No</label>
                </div>
            </div>

            <div className="p-col-12 p-md-6 p-lg-4">
                <label className="label">Enable QR Ordering?</label>
                <div className="mt1">
                    <RadioButton inputId="qrYes" name="qrOrder" value="Yes"
                        checked={this.state.qrOrder === 'Yes'} onChange={this.handleChange} />
                    <label htmlFor="qrYes" className="ml05 mr1">Yes</label>

                    <RadioButton inputId="qrNo" name="qrOrder" value="No"
                        checked={this.state.qrOrder === 'No'} onChange={this.handleChange} />
                    <label htmlFor="qrNo" className="ml05">No</label>
                </div>
            </div>
            </div>
            </div>
            </div>

        </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.master.loading,
    error: state.master.error,
    success: state.master.success,
});

const mapDispatchToProps = {
    getKeywordValues
};

export default connect(mapStateToProps, mapDispatchToProps)(InventorySettings);